/* eslint-disable react/no-array-index-key */
import React, { Children, ReactNode } from 'react'

import BenefitListContext from './BenefitListContext'

type BenefitListProps = {
  attached?: boolean
  children?: ReactNode
}

const BenefitList = ({ attached = false, children: propsChildren }: BenefitListProps) => {
  const children = Children.toArray(propsChildren)
  return (
    <>
      {children.map((child, i) => (
        <BenefitListContext.Provider
          key={i}
          value={{
            dark: i % 2 === 1,
            roundedBottom: i === children.length - 1,
            roundedTop: i === 0 && !attached,
          }}
        >
          {child}
        </BenefitListContext.Provider>
      ))}
    </>
  )
}

export default BenefitList
